<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Izveštaj prekovremenih sati</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <p-datepicker #monthPicker
                      [(ngModel)]="selectedMonth"
                      [ngModelOptions]="{standalone: true}"
                      [view]="'month'"
                      [dateFormat]="'mm/yy'"
                      [placeholder]="'Izaberi mesec'"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      [appendTo]="'body'"
                      [showButtonBar]="true"
                      (onSelect)="onSelectMonth($event, monthPicker)"
                      [readonlyInput]="true">
          </p-datepicker>

        </div>
      </div>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question me-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()">Preuzmi</button>
    </div>
  </div>
</div>